/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-avatar-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 3.125a2.813 2.813 0 11-2.813 2.813A2.806 2.806 0 0110 4.374zm5 11.2a7.456 7.456 0 01-10 0v-.362a3.25 3.25 0 013.125-3.338h3.75A3.256 3.256 0 0115 15.194v.381z"/>'
  }
})
